export default (props, vars) =>
  vars?.['defaultbox145']?.['item']?.['status'] === 'COMPLETED' &&
  !!vars?.['defaultbox145']?.['item']?.['completion_date'];
